module.exports = __webpack_public_path__ + "assets/img/logo-jx2-2a456c7b.png";